import {LanguageSymbol} from '../../enums';
// USA
export const locale = {
  lang: LanguageSymbol.ENGLISH,
  data: {
    APP: {
      NAME: 'PORTAL',
      GENERAL: {
        LANGUAGE: 'Language',
        ENGLISH: 'English',
        SPANISH: 'Spanish',
        AND: 'and',
        EDIT: 'Edit',
        REMOVE: 'Remove',
        BACK: 'Back',
        OK_GOT_IT: 'OK, Got it!',
        CONTINUE: 'Continue',
        IGNORE: 'Ignore',
        SUBMIT: 'Submit',
        FINISH: 'Finish',
        CLOSE: 'Close',
        ADD: 'Add',
        UPDATE: 'Update',
        COMPLETE_SUBSCRIPTION: 'Complete Subscription',
      },
      SIGNUP: {
        FIELD: {
          ZIPCODE: 'Zip Code',
          MCS_CARDHOLDER: 'MCS Cardholder #',
          REFERRAL_CODE: 'Referral Code',
          GIVEN_NAME: 'Given Name',
          SECOND_NAME: 'Second Name',
          FAMILY_NAME: 'Family Name',
          MOTHERS_MAIDEN_FAMILY_NAME: 'Mother\'s Maiden Family Name',
          DATE_OF_BIRTH: 'Date of Birth',
          GENDER: 'Gender',
          CELL_NUMBER: 'Cell Number',
          HOME_NUMBER: 'Home Number',
          FAX_NUMBER: 'Fax Number',
          EMAIL: 'Email',
          USERNAME: 'Username',
          PASSWORD: 'Password',
          RE_PASSWORD: 'Re-Password',
          DELIVERY_ZIPCODE: 'Delivery Zip Code',
          HOME: 'Home',
          OFFICE: 'Office',
          OTHER: 'Institution',
          URBANIZATION: 'Urbanization',
          INSTITUTION: 'Institution',
          ADDRESS_LINE1: 'Address line 1',
          ADDRESS_LINE2: 'Address line 2',
          CITY: 'City',
          STATE: 'State',
          ZIPCODE_4CODE: 'Zip Code + 4Code',
          DELIVERY_INSTRUCTIONS: 'Delivery instructions',
          PRESS123_AT_FRONT_GATE: 'Press \'123\' at front gate.',
          PREFERRED_ADDRESS: 'Preferred Address',
          TYPE_OF_ADDRESS: 'Type of Address',
          CATEGORY: 'Category',
          IMAGE: 'Image',
          SKU: 'SKU',
          NAME: 'Name',
          COUNT: 'Count',
          PRICE: 'Price',
          VALIDATION: {
            REQUIRED: '{{label}} is required',
            INVALID: 'Invalid {{label}}',
            NO_WHITESPACE: 'Invalid {{label}}: Whitespaces are not allowed',
            MIN: '{{label}} must be greater than {{min}}',
            EXISTS: '{{label}} already in use',
            PATTERN: '{{label}} must match the pattern',
            PW_MATCH: 'Passwords don\'t match',
          },
        },
        PROGRAM_TYPE: {
          MCS_PROGRAMS: 'MCS Programs',
          SELECT_PROGRAM_YOU_WANT_TO_REGISTER_FOR: 'Select program you want to register for.',
          REGISTRATION_PROCESS_MAY_DIFFER_BASED_ON_YOUR_SELECTION: 'Registration process may differ based on your selection.',
          HOME_PROGRAM: 'MCS Care Program',
          REGISTER_FOR_THE_MCS_HOME_PROGRAM: 'Register for the MCS Care Program',
          BY_MAKING_A_SELECTION_YOU_AGREE_WITH_OUR: 'By making a selection, you agree with our',
          TERMS_OF_SERVICES: 'Terms of Services',
          PRIVACY_POLICY: 'Privacy Policy',
        },
        CHECK_ELIGIBILITY: {
          ELIGIBILITY_CHECK: 'Eligibility Check',
          CHECK_IF_THE_PATIENT_IS_ELIGIBLE_FOR_THIS_PROGRAM: 'Check if the patient is eligible for this Program.',
          INVALID_DATA_PROVIDED: 'The data provided does not match our systems. Please check your cardholder # and date of birth, then retry again.',
          ALREADY_ENROLLED: 'This cardholder has already been enrolled. Please contact customer support for any modifications.',
        },
        BASIC_INFO: {
          BASIC_INFORMATION: 'Basic Information',
          ADD_YOUR_BASIC_INFORMATION: 'Add your basic information.',
          ALREADY_EXIST_PART_1: 'A contact with this phone number already exists. Please attempt to ',
          ALREADY_EXIST_PART_2: ' with your Medplus User ID or if you believe this is an error, please contact our help desk.',
          LOGIN: 'login',
        },
        CREATE_ACCOUNT: {
          CREATE_ACCOUNT: 'Create Account',
          ADD_YOUR_USERNAME_AND_PASSWORD: 'Add your username and password.',
          GREAT_NEWS: 'Great News! You are eligible for this program, please add your username and password.',
          MIN_8CHARS: '8 characters or more',
          MIN_1UPPERCASE: 'At least 1 uppercase letter',
          MIN_1NUMBER: 'At least 1 number',
          MIN_1SPECIAL: 'At least 1 special character',
        },
        DELIVERY_ADDRESS: {
          DELIVERY_ADDRESS: 'Delivery Address',
          ADD_YOUR_DELIVERY_ADDRESS: 'Add your delivery address.',
          YOUR_DELIVERY_ADDRESSES: 'Your Delivery Addresses',
          ADD_NEW_ADDRESS: 'Add a new address',
          NO_ADDRESS_ADDED: 'No address added!',
          ONLY_ONE_ADDRESS_CAN_BE_PREFERRED: 'Only one address can be preferred.',
          ONLY_ONE_ADDRESS_CAN_BE_ADDED: 'Only one address can be added for each type. If the Institution type is selected, then only that address is allowed.',
          AT_LEAST_ONE_ADDRESS_SHOULD_BE_ADDED: 'At least one address should be added.',
          SORRY_WE_CANT_REMOVE_PREFERRED_ADDRESS: 'Sorry, we can\'t remove the preferred address.',
          SORRY_YOU_CANT_ADD_MULTIPLE_ADDRESSES_WITH_INSTITUTION_TYPE: 'Sorry, you can\'t add multiple addresses with an address of Institution type.',
          SORRY_YOU_CANT_ADD_MULTIPLE_ADDRESSES_OF_SAME_TYPE: 'Sorry, you can\'t add multiple addresses of the same type.',
        },
        ORDER: {
          ORDER_PRODUCTS: 'Order Products',
          SELECT_ORDER_TYPE: 'Select either to order manually by phone/mobile app or to create a monthly delivery schedule.',
          ORDER_MANUALLY: 'Order manually by phone or mobile app',
          ORDER_MONTHLY: 'Create a monthly delivery schedule',
          BENEFIT: 'Benefit',
          SELECTED_PRODUCTS_TOTALS: 'Selected Products Totals',
          SELECTED_PRODUCTS_LIST: 'Selected Products List',
          NO_PRODUCTS_SELECTED: 'No Products were Selected!',
          TOTAL_COUNT: 'Count',
          TOTAL_COST: 'Total Cost',
          PRODUCTS_COST: 'Products',
          TOTAL_TAX: 'Tax',
          VIEW_SELECTED_PRODUCTS_LIST: 'View selected products list',
          CREATE_YOUR_MONTHLY_SHIPMENT: 'Create your Recurring Monthly Shipment',
          ADD_PRODUCTS_WITHOUT_EXCEEDING_YOUR_LIMIT: 'Add products without exceeding your limit.',
          YOU_HAVE_REQUESTED_ITEMS_THAT_EXCEED_YOUR_BENEFITS_AMOUNT: 'You have requested items that exceed your Benefits amount. Please remove items from your order to continue.',
          NO_ITEMS_SELECTED: 'No items were selected! please select at least one to complete your subscription.',
        },
        DONE: {
          YOU_ARE_SET: 'You are Set!',
          WHATS_NEXT: 'What\'s Next?',
          CONGRATULATIONS_YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED: 'Congratulations! You have been successfully registered.',
          THANK_YOU_FOR_YOUR_TIME: 'Thank you for your time. Please feel free to leave this page at any time, or you can login from ',
          HERE: 'here',
        },
      },
    },
  },
};
